import ChartingBaseController from './charting_base_controller';

export default class extends ChartingBaseController {
  static values = {
    reactions: { type: Array, default: [] },
    active: { type: Boolean, default: false }
  };

  activeValueChanged(current, previous) {
    if (current && !this.element.open) {
      this.element.showModal();
    } else if (!current && this.element.open && previous !== undefined) {
      this.element.close();
    }
  }

  close() {
    const form = this.formWriter;
    if (!form) {
      this.element.close();
      return;
    }

    this.reactionsValue.forEach((reaction) => {
      if (reaction.action !== 'active') return;

      ChartingBaseController.namespacesFor(reaction).forEach((namespace) => {
        if (reaction.from === 'filters') {
          form.removeFilter(namespace, reaction.watch);
        } else {
          form.setVisual(namespace, reaction.watch, null);
        }
      });
    });

    form.submit();
  }

  backdropClick(event) {
    if (event.target === this.element) {
      this.close();
    }
  }
}
